import React from "react";
import BasicCustomField from "../BasicCustomField";
import { Selection } from "../../../../../../src/application/Contracts";
import TankResultModel = Selection.TankResultModel;
import TankInsulation = Selection.TankInsulation;
import InspectionHole = Selection.InspectionHole;
import formModelStore from "../../../../../store/FormModelStore";
import { EnumsTextHelper } from "../../EnumsTextHelper";
import ArrowsIcon from "../icons/ArrowsIcon";
import getInspectionHoleName = Selection.getInspectionHoleName;

export default class TwsTankSelectionResult extends BasicCustomField {
    state = {
        value: this.props.value,
        additionalModel: this.props.additionalModel,
    }
    onChangeInput = (tankResult: TankResultModel) => {
        this.onChange(tankResult);
    }
    renderRow = (tankResult: TankResultModel) => {
        return <tr key={tankResult.ref}>
            <td>
                <div className={`table-radio-button`}>
                    <input id={`tank-selection-result-model-${tankResult.ref}`} type={"radio"}
                        checked={this.checkedRow(tankResult.ref)}
                        name={`tank-selection-result-model`}
                        onChange={() => this.onChangeInput(tankResult)} />
                    <label htmlFor={`tank-selection-result-model-${tankResult.ref}`}></label>
                </div>
            </td>
            <td>{tankResult.articleNumber ?? 0}<br />{tankResult.tankFamily}</td>
            <td>{tankResult.tankValume ?? 0}<br />{__(tankResult.material)}</td>
            <td>{tankResult.insulation}<br />{__(getInspectionHoleName(tankResult.inspection))}</td>
            <td>{tankResult.maxPs ?? 0}<br />{tankResult.maxTs}</td>
            <td>{tankResult.pscoil ?? 0}<br />{tankResult.tscoil}</td>
            <td>{tankResult.diam ?? 0}<br />{tankResult.height}</td>
        </tr>
    }

    clear = () => {
        this.setState({ value: null });
        formModelStore.formModel.tankSelection.results.value.tankTechnicalData = null;
    }

    checkedRow = (row: number) => {
        return formModelStore.formModel?.tankSelection?.selectedTank?.value?.ref === row;
    }
    renderEmpty = () => {
        return <div className={`empty-expandable-container-results`}>{__('No tank selection results')}</div>
    }

    render() {
        if ((this.props.additionalModel as TankResultModel[]).length === 0) {
            return this.renderEmpty();
        }

        return <React.Fragment>
            <table className={`step-stripped-table data-only`}>
                <thead>
                    <tr>
                        <th></th>
                        <th>{__('Art.No')}<br />{__('Tank Family')}</th>
                        <th>{__('Volume (L)')}<br />{__('Material')}</th>
                        <th>{__('Insulation')}<br />{__('Inspection')}</th>
                        <th>{__('Max Ps')}<br />{__('Max Ts')}</th>
                        <th>{__('Pscoil')}<br />{__('Tscoil')}</th>
                        <th>{__('Diam')}<br />{__('Height')}</th>
                    </tr>
                </thead>
                <tbody>
                    {(this.props.additionalModel as TankResultModel[]).map(tankResult => this.renderRow(tankResult))}
                </tbody>
            </table>
        </React.Fragment>
    }
}